
export default function StarRating({ count = 5, value = 0, onChange }) {
  const handleClick = (index) => {
    onChange(index + 1);
  };

  return (
    <div style={{ display: 'flex', gap: 4 }}>
      {[...Array(count)].map((_, index) => (
        <span
          key={index}
          onClick={() => handleClick(index)}
          style={{
            cursor: 'pointer',
            fontSize: 24,
            color: index < value ? '#ffd700' : '#ccc',
          }}
        >
          ★
        </span>
      ))}
    </div>
  );
};